import { HTTP_STATUS } from "constants/httpStatusCodes";

export const HTTP_STATUS_MESSAGES = {
  [HTTP_STATUS.BAD_REQUEST]: "Invalid parameters provided",
  [HTTP_STATUS.UNAUTHORIZED]: "Authentication required",
  [HTTP_STATUS.FORBIDDEN]: "Access denied",
  [HTTP_STATUS.NOT_FOUND]: "Resource not found",
  [HTTP_STATUS.CONFLICT]: "Resource already exists",
  [HTTP_STATUS.UNPROCESSABLE_ENTITY]: "Validation failed",
  [HTTP_STATUS.TOO_MANY_REQUESTS]: "Too many requests. Please try again later.",
  [HTTP_STATUS.INTERNAL_SERVER_ERROR]:
    "Something went wrong, please try again later",
  [HTTP_STATUS.BAD_GATEWAY]: "Something went wrong, please try again later",
  [HTTP_STATUS.SERVICE_UNAVAILABLE]:
    "Service unavailable. Please try again later",
  [HTTP_STATUS.GATEWAY_TIMEOUT]:
    "Server took too long to respond, please try again later",
};

export const NETWORK_ERROR_MESSAGE =
  "Network error — please check your connection";

export const SESSION_EXPIRED_MESSAGE =
  "It seems your session has expired. Please log in again.";
